import React, {
    useEffect,
    useState
} from "react";
import useRepeatables
    from "../../../hooks/useRepeatables";
import {
    DeleteOutlined,
    KeyboardArrowDownOutlined,
    KeyboardArrowLeftOutlined,
    KeyboardArrowRightOutlined,
    KeyboardArrowUpOutlined,
    AddOutlined
} from "@mui/icons-material";
import IconButton
    from "@mui/material/IconButton";
import styled
    from "styled-components";

const FormRepeatableLegend = styled.legend`
    display: flex;
    align-items: center;
  
    &:hover {
        cursor: pointer;
    }
`;

const FormRepeatableNavigation = styled.nav`
    display: flex;
  gap: 0.8rem;
  margin-bottom: 2rem;
`

const FormRepeatable = ({
                            template,
                            defaultAnswer,
                            subheaderRow= 0
                        }) => {
    const [open, setOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(0);

    const {addRow, childElements, rows} = useRepeatables({
        template,
        defaultAnswer,
        subheaderRow,
        type: 'repeatable',
        showButtons: false
    });

    const handleOpen = (e) => {
        setOpen(!open);

        if (rows === 0) {
            setCurrentRow(1);
            addRow(e);
        }

        if (rows > 0 && currentRow === 0) {
            setCurrentRow(1);
        }
    }

    return (
        <div className='fz-form-field-group fz-form-field-element-repeatable'>
            <fieldset className='fz-form-fieldset fz-form-fieldset-repeatable'>
                <FormRepeatableLegend className="fz-form-legend fz-form-repeatable-legend"
                                      onClick={handleOpen}>{template.content.value} {currentRow}/{rows} <IconButton sx={{backgroundColor: '#eee', marginLeft: '0.8rem'}} className='fz-form-button fz-form-repeatable-add-button fz-form-element-repeatable-button' onClick={handleOpen}>{open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}</IconButton></FormRepeatableLegend>
                <div style={{display: open ? 'block' : 'none'}}>
                    {childElements(({onDelete}) => (
                        <FormRepeatableNavigation>
                            <IconButton sx={{backgroundColor: '#eee'}} onClick={e => {
                                e.preventDefault();

                                if (currentRow === 1) {
                                    return setCurrentRow(rows);
                                }

                                setCurrentRow(currentRow - 1);
                            }}><KeyboardArrowLeftOutlined /></IconButton>
                            {template.content.disableDelete === false && (
                                <IconButton sx={{backgroundColor: '#eee'}} onClick={e => {
                                    e.preventDefault();

                                    onDelete(e);

                                    if ((rows - 1) === 0) {
                                        setOpen(false);
                                    }

                                    if (currentRow > 1 || currentRow === 1 && rows === 1) {
                                        setCurrentRow(currentRow - 1);
                                    }
                                }}><DeleteOutlined/></IconButton>
                            )}
                            <IconButton onClick={e => {
                                e.preventDefault();

                                if (currentRow === rows && template.content.disableNewRow === false) {
                                    addRow(e);
                                }

                                if (currentRow === rows && template.content.disableNewRow === true) {
                                    setCurrentRow(1);
                                    return;
                                }

                                setCurrentRow(currentRow + 1);
                            }} sx={{backgroundColor: '#eee'}}>{currentRow === rows && template.content.disableNewRow === false ? <AddOutlined /> : <KeyboardArrowRightOutlined />}</IconButton>
                        </FormRepeatableNavigation>
                    ), currentRow)}
                </div>
            </fieldset>
        </div>
    )
}

export default FormRepeatable;